// @ts-ignore
import ColorThief from "colorthief";
import React, { PropsWithChildren, type FC } from "react";
import classes from "./BackgroundMovieLayout.module.css";

type BackgroundLayoutPropType = PropsWithChildren<{
  backdropImage: string;
  windowWidth: number;
}>;

const BackgroundMovieLayout: FC<BackgroundLayoutPropType> = ({
  children,
  backdropImage,
  windowWidth,
}) => {
  return (
    <div className={classes.background_wrapper}>
      <div
        className={classes.background_movie}
        style={{
          background:
            backdropImage === "error"
              ? undefined
              : windowWidth > 530
              ? `linear-gradient(to bottom,#0F1014,transparent,#0F1014),url(${process.env.REACT_APP_BACKDROP_MEDIA_PATH_PREFIX}${backdropImage})`
              : `linear-gradient(to bottom,#0F1014,transparent,#0F1014),url(${process.env.REACT_APP_BACKDROP_SMALL_MEDIA_PATH_PREFIX?.replace(
                  "<replace_media_id>",
                  backdropImage
                )})`,
          // background: `linear-gradient(to bottom,#0F1014,transparent,#0F1014),url(https://image.tmdb.org/t/p/w533_and_h300_bestv2${backdropImage})`,
        }}
      ></div>
      <div className={classes.wrapper}>{children}</div>
    </div>
  );
};

export default BackgroundMovieLayout;
